<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="break-tag"> </p>
<a id="O600000002">
<p class="para3"><img alt="" src="p20003ed5giii002.jpg"/></p>
<p class="para7"><strong>Dorothy Garlock</strong></p>
<p class="para8"><strong>POPULAR LIBRARY</strong></p>
<p class="para3"><img alt="" src="p20003ed5giii001.jpg"/></p>
<p class="break-tag"> </p>
<p class="para9">An Imprint of Warner Books, Inc.</p>
<p class="para8">A Time Warner Company</p>
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 20003ed5frontv01.vue?6d6b59b2